import { View, StyleSheet } from "react-native";
import React from "react";
import { Text } from "@ui-kitten/components";
import ProfileAvatar from "components/ProfileAvatar";
import useCurrentUser from "hooks/useCurrentUser";
import CustomerWallet from "./CustomerWallet";
import Spacer from "components/Spacer";
import i18n from "plugins/localization";
import { Image } from "expo-image";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import { getUserName, initial } from "utils/userUtils";
import { svgURL } from "utils/fileUtils";

const LOGO_SIZE = 70;
const Header = () => {
  const { data: branding } = useFetchTenantBrandingQuery();
  const { currentUser, userImageURL } = useCurrentUser();

  if (!branding) return null;

  const { name, primaryColor } = branding;
  return (
    <View style={[styles.headerContainer, { backgroundColor: primaryColor }]}>
      {currentUser !== undefined && (
        <>
          <View style={styles.userDetailsContainer}>
            <View
              style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
            >
              <View style={{ flex: 0.2 }}>
                <ProfileAvatar
                  hasImageIdentifier={!!currentUser.imageIdentifier}
                  source={{
                    uri: userImageURL,
                  }}
                  initial={initial(currentUser)}
                  size={48}
                />
              </View>
              <View style={{ flex: 0.7 }}>
                <Text style={{ fontSize: 14 }} appearance="hint">
                  {i18n.t("screens.Dashboard.hello") as string},
                </Text>
                <Text status="control" style={{ fontSize: 18 }}>
                  {getUserName(currentUser)}
                </Text>
              </View>
            </View>
            <View style={{ flex: 0.1 }}>
              <View style={styles.logo}>
                <Image
                  source={{ uri: svgURL(name) }}
                  style={{
                    width: LOGO_SIZE,
                    height: LOGO_SIZE,
                  }}
                  responsivePolicy="initial"
                  contentFit="contain"
                />
              </View>
            </View>
          </View>
          <Spacer />
          <CustomerWallet />
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    borderRadius: 12,
    padding: 14,
    paddingBottom: 0,
    overflow: "hidden",
    marginBottom: 14,
  },
  userGreetingContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  userDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logo: {
    position: "absolute",
    right: 0,
    top: -(LOGO_SIZE / 2),
  },
});
export default Header;
